export const DATE_RANGE_PRESETS = {
  last_7_days: {
    key: "last_7_days",
    label: "Last 7 Days",
    calculateRange: () => {
      const now = new Date();
      const from = new Date();
      from.setDate(now.getDate() - 6);
      from.setHours(0, 0, 0, 0);
      now.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: now.toISOString() };
    },
  },
  last_14_days: {
    key: "last_14_days",
    label: "Last 14 Days",
    calculateRange: () => {
      const now = new Date();
      const from = new Date();
      from.setDate(now.getDate() - 13);
      from.setHours(0, 0, 0, 0);
      now.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: now.toISOString() };
    },
  },
  last_30_days: {
    key: "last_30_days",
    label: "Last 30 Days",
    calculateRange: () => {
      const now = new Date();
      const from = new Date();
      from.setDate(now.getDate() - 29);
      from.setHours(0, 0, 0, 0);
      now.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: now.toISOString() };
    },
  },
  this_week: {
    key: "this_week",
    label: "This Week",
    calculateRange: () => {
      const now = new Date();
      const from = new Date();
      from.setDate(from.getDate() - from.getDay());
      from.setHours(0, 0, 0, 0);
      now.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: now.toISOString() };
    },
  },
  last_week: {
    key: "last_week",
    label: "Last Week",
    calculateRange: () => {
      const from = new Date();
      from.setDate(from.getDate() - 7 - from.getDay());
      from.setHours(0, 0, 0, 0);
      const to = new Date();
      to.setDate(to.getDate() - to.getDay() - 1);
      to.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: to.toISOString() };
    },
  },
  this_month: {
    key: "this_month",
    label: "This Month",
    calculateRange: () => {
      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth(), 1);
      from.setHours(0, 0, 0, 0);
      now.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: now.toISOString() };
    },
  },
  last_month: {
    key: "last_month",
    label: "Last Month",
    calculateRange: () => {
      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      from.setHours(0, 0, 0, 0);
      const to = new Date(now.getFullYear(), now.getMonth(), 0);
      to.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: to.toISOString() };
    },
  },
  last_3_months: {
    key: "last_3_months",
    label: "Last 3 Months",
    calculateRange: () => {
      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth() - 3, 1);
      from.setHours(0, 0, 0, 0);
      const to = new Date(now.getFullYear(), now.getMonth(), 0);
      to.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: to.toISOString() };
    },
  },
  this_year: {
    key: "this_year",
    label: "This Year",
    calculateRange: () => {
      const now = new Date();
      const from = new Date(now.getFullYear(), 0, 1);
      from.setHours(0, 0, 0, 0);
      now.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: now.toISOString() };
    },
  },
} as const;

export type DateRangePresetKey = keyof typeof DATE_RANGE_PRESETS;
